import { RouteConfig } from "vue-router";

const tipoCargos: RouteConfig = {
  path: "/tipoCargos",
  name: "tipoCargos",
  component: () => import(/* webpackChunkName: "tipo-cargos" */ "@/views/TipoCargos.vue"),
};

export default tipoCargos;
